import Table from '@/common/components/Table'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { Mapper } from '@/common/services/mapper'
import { useParams } from 'react-router-dom'
import { useClientEquipmentUsageDeclarationsHistory } from '../../hooks/equipments/useClientEquipmentUsageDeclarationsHistory';
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper';
import { EquipmentUsageDeclarationsHistoryTransformer } from '../../services/equipments/equipmentUsageDeclarationsHistoryTransformer';
import { clientEquipmentUsageDeclarationsHistoryColumns } from '../../constants/equipments/clientEquipmentUsageDeclarationsHistoryColumns.constant';
import { DatePickerWithRange } from '@/common/components/ui/dateRangePicker';
import { useFilterDate } from '@/common/hooks/useFilterDate';
import ListFilters from '@/common/components/ListFilters';
import { useProductCategories } from '@/common/hooks/queries/useProductCategories';
import useDebounce from '@/common/hooks/useDebounce';
import { ProductCategoryData } from '@/common/types/productCategory.type';
import { Option } from '@/common/types/option';

export const ClientEquipmentUsageDeclarationsHistory = () => {
  const { id: equipmentId } = useParams()

  const { filterParams, setFilterParams } = useFilterParams();
  
  const { date, formattedDate } = useFilterDate(filterParams);

  const [searchProductCategories, setSearchProductCategories] = useDebounce('');

  const { data: productCategoriesOptions, isPending: productCategoriesIsPending } = useProductCategories({
    filters: { search: searchProductCategories },
    mapper: Mapper.mapToOptions<ProductCategoryData>({ labelFieldName: 'display_name', valueFieldName: 'id' }),
  });

  const {
    data: equipmentUsageDeclarationsHistory,
    meta: equipmentUsageDeclarationsHistoryMeta,
    isPending: equipmentUsageDeclarationsHistoryIsPending,
    error: equipmentUsageDeclarationsHistoryError = {} as any,
    refetch: equipmentUsageDeclarationsHistoryRefetch
  } = useClientEquipmentUsageDeclarationsHistory({
    equipmentId,
    filters: {
      page: filterParams.page || 1,
      createdAtStartDate: formattedDate.from,
      createdAtEndDate: formattedDate.to,
      productCategoryId: filterParams.productCategoryId?.value
    },
    mapper: Mapper.mapWithTransformer({
      transformer: EquipmentUsageDeclarationsHistoryTransformer.tableTransformer(),
    }),
  })

  return (
    <ErrorMessageWrapper
      className="h-[calc(100vh-128px)]"
      statusCode={equipmentUsageDeclarationsHistoryError?.status}
      refetchFunction={equipmentUsageDeclarationsHistoryRefetch}
    >
      <div className="flex flex-col gap-6 flex-1 overflow-auto">
        <div className="flex items-center justify-start gap-2">
          <ListFilters
            filters={[
              {
                className: '',
                onChange: (productCategoryId) => setFilterParams((prev) => ({ ...prev, productCategoryId })),
                onInputChange: setSearchProductCategories,
                value: filterParams.productCategoryId,
                options: [{ label: 'Todos', value: '' }, ...productCategoriesOptions as Option[]],
                disabled: productCategoriesIsPending,
                placeholder: 'Serviço'
              },
            ]}
          />

          <DatePickerWithRange date={date} setDate={(date) => setFilterParams((prev) => ({ ...prev, date }))} />
        </div>

        <Table
          className="max-h-[calc(100vh-192px)]"
          columns={clientEquipmentUsageDeclarationsHistoryColumns}
          isLoadingData={equipmentUsageDeclarationsHistoryIsPending}
          rows={equipmentUsageDeclarationsHistory}
          rowEmptyValue="--"
          page={filterParams.page || 1}
          setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
          totalPages={equipmentUsageDeclarationsHistoryMeta.total_pages}
          totalCount={equipmentUsageDeclarationsHistoryMeta.total}
          hasPagination
        />
      </div>
    </ErrorMessageWrapper>

  )
}
